/**
 * Sale countdown timers (PDP block + header banner). Plain DOM + setInterval — no custom
 * elements (avoids upgrade / sanitizer issues). Re-inits after product AJAX and section loads.
 */
(function () {
  if (window.__ksSaleTimersBoot) return;
  window.__ksSaleTimersBoot = true;

  function pad2(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function clearKs(root) {
    if (root && root._ksInterval) {
      clearInterval(root._ksInterval);
      root._ksInterval = null;
    }
  }

  function startPdp(root) {
    clearKs(root);
    var ds = root.dataset;
    var mode = ds.ksMode || root.getAttribute("data-ks-mode") || "rolling";
    var endDateStr = (
      ds.ksEndDate ||
      root.getAttribute("data-ks-end-date") ||
      root.getAttribute("end-date") ||
      ""
    ).trim();
    var durationHours = parseFloat(String(ds.ksDurationHours || "24")) || 24;
    var storageKey =
      ds.ksStorageKey || root.getAttribute("data-ks-storage-key") || root.getAttribute("data-storage-key") || "";
    var expiredText = ds.ksExpiredText || "";
    var showDays = ds.ksShowDays === "true";
    var showHours = ds.ksShowHours === "true";
    var showMinutes = ds.ksShowMinutes === "true";
    var showSeconds = ds.ksShowSeconds === "true";
    var classBase = ds.ksClassBase || root.className.trim().split(/\s+/)[0] || "ks-st";

    function resolveEndTime() {
      if (mode === "fixed") {
        if (!endDateStr) return Date.now();
        var value = String(endDateStr).trim();
        if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(:\d{2})?$/.test(value)) value = value.replace(" ", "T");
        var parsed = Date.parse(value);
        return isNaN(parsed) ? Date.now() : parsed;
      }
      try {
        var stored = localStorage.getItem(storageKey);
        var now = Date.now();
        if (stored) {
          var et = parseInt(stored, 10);
          if (!isNaN(et) && et > now) return et;
        }
        var newEnd = now + durationHours * 60 * 60 * 1000;
        localStorage.setItem(storageKey, String(newEnd));
        return newEnd;
      } catch (e) {
        return now + durationHours * 60 * 60 * 1000;
      }
    }

    function setUnit(unit, value) {
      var el =
        root.querySelector('[data-ks-u="' + unit + '"]') ||
        root.querySelector('[ks-u="' + unit + '"]') ||
        root.querySelector('[data-ks-digit="' + unit + '"]');
      if (el) el.textContent = pad2(value);
    }

    var endTime = resolveEndTime();

    function tick() {
      if (!root.isConnected) {
        clearKs(root);
        return;
      }
      var remaining = Math.max(0, endTime - Date.now());
      if (remaining <= 0 && mode === "rolling") {
        try {
          localStorage.removeItem(storageKey);
        } catch (e2) {}
        endTime = resolveEndTime();
        remaining = Math.max(0, endTime - Date.now());
      }
      if (remaining <= 0 && mode === "fixed") {
        if (expiredText) {
          root.innerHTML = '<span class="' + classBase + '__label">' + expiredText + "</span>";
        } else {
          root.style.display = "none";
        }
        clearKs(root);
        return;
      }
      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;
      if (!showDays) {
        hours += days * 24;
        days = 0;
      }
      if (!showHours) {
        minutes += hours * 60;
        hours = 0;
      }
      if (!showMinutes) {
        seconds += minutes * 60;
        minutes = 0;
      }
      setUnit("days", days);
      setUnit("hours", hours);
      setUnit("minutes", minutes);
      setUnit("seconds", seconds);
    }

    tick();
    root._ksInterval = setInterval(tick, 1000);
  }

  function startHdr(root) {
    clearKs(root);
    var resetAtMidnight = root.dataset.ksResetMidnight === "true";
    var hideOnComplete = root.dataset.ksHideComplete === "true";
    var useIP = root.dataset.ksUseIp === "true";
    var daysEl = root.querySelector('[data-ks-u="d"]');
    var hoursEl = root.querySelector('[data-ks-u="h"]');
    var minEl = root.querySelector('[data-ks-u="m"]');
    var secEl = root.querySelector('[data-ks-u="s"]');
    if (!hoursEl || !minEl || !secEl) return;

    function getUserTz() {
      try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      } catch (e) {
        return null;
      }
    }

    function getNextMidnightInTz(tz) {
      var now = new Date();
      var formatter = new Intl.DateTimeFormat("en-CA", {
        timeZone: tz,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
      });
      var parts = formatter.formatToParts(now);
      function gv(t) {
        var p = parts.find(function (x) {
          return x.type === t;
        });
        return p ? parseInt(p.value, 10) : 0;
      }
      var tzNow = {
        hour: gv("hour"),
        minute: gv("minute"),
        second: gv("second")
      };
      var secLeft = 24 * 3600 - tzNow.hour * 3600 - tzNow.minute * 60 - tzNow.second;
      var msLeft = secLeft * 1000 - now.getMilliseconds();
      return new Date(now.getTime() + msLeft);
    }

    function getNextMidnight(syncOnly) {
      if (syncOnly) {
        var tz = getUserTz();
        if (tz) return getNextMidnightInTz(tz);
        var nm = new Date();
        nm.setHours(24, 0, 0, 0);
        return nm;
      }
      return fetch("https://worldtimeapi.org/api/ip", { method: "GET" })
        .then(function (r) {
          return r.ok ? r.json() : {};
        })
        .then(function (data) {
          if (data && data.timezone) return getNextMidnightInTz(data.timezone);
          var t = getUserTz();
          if (t) return getNextMidnightInTz(t);
          var x = new Date();
          x.setHours(24, 0, 0, 0);
          return x;
        })
        .catch(function () {
          return getNextMidnight(true);
        });
    }

    function getFixedTarget() {
      var y = parseInt(root.dataset.ksYear, 10);
      var mo = parseInt(root.dataset.ksMonth, 10) - 1;
      var d = parseInt(root.dataset.ksDay, 10);
      var h = parseInt(root.dataset.ksHour, 10);
      var mi = parseInt(root.dataset.ksMinute, 10);
      return new Date(y, mo, d, h, mi, 0);
    }

    function getTarget() {
      if (resetAtMidnight) {
        return useIP ? getNextMidnight(false) : Promise.resolve(getNextMidnight(true));
      }
      return Promise.resolve(getFixedTarget());
    }

    var targetDate = null;

    function update() {
      if (!root.isConnected) {
        clearKs(root);
        return;
      }
      if (!targetDate) return;
      var now = new Date();
      var diff = targetDate - now;

      if (resetAtMidnight && diff <= 0) {
        var nx = useIP ? getNextMidnight(false) : Promise.resolve(getNextMidnight(true));
        if (nx && typeof nx.then === "function") {
          nx.then(function (dt) {
            targetDate = dt;
            update();
          });
          return;
        }
        targetDate = nx;
        diff = targetDate - now;
      }

      if (diff <= 0) {
        if (daysEl) daysEl.textContent = "00";
        hoursEl.textContent = "00";
        minEl.textContent = "00";
        secEl.textContent = "00";
        if (hideOnComplete) {
          var ban = root.closest(".maison-timer-banner");
          if (ban) ban.classList.add("timer-hidden");
          else root.style.display = "none";
        }
        clearKs(root);
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);
      if (!daysEl) {
        hours += days * 24;
      }
      if (daysEl) daysEl.textContent = pad2(days);
      hoursEl.textContent = pad2(hours);
      minEl.textContent = pad2(minutes);
      secEl.textContent = pad2(seconds);
    }

    getTarget().then(function (d) {
      targetDate = d;
      update();
      root._ksInterval = setInterval(update, 1000);
    });
  }

  function normalizeKind(raw) {
    var k = (raw || "").toLowerCase().replace(/_/g, "-");
    if (k === "pdp" || k === "countdown-timer" || k === "countdown_timer") return "pdp";
    if (k === "hdr" || k === "banner" || k === "header") return "hdr";
    return k;
  }

  function inferKind(root) {
    var k = normalizeKind(root.getAttribute("data-ks-kind"));
    if (k === "pdp" || k === "hdr") return k;
    if (root.getAttribute("data-ks-mode") || root.dataset.ksMode) return "pdp";
    if (root.querySelector('[data-ks-u="d"],[ks-u="d"]')) return "hdr";
    return "";
  }

  function boot() {
    document.querySelectorAll("[data-ks-timer-root]").forEach(function (root) {
      if (root.getAttribute("data-ks-armed") === "1" || root.getAttribute("data-armed") === "1") {
        if (root._ksInterval) return;
        root.removeAttribute("data-ks-armed");
        root.removeAttribute("data-armed");
      }
      var kind = inferKind(root);
      if (!kind) return;
      try {
        if (kind === "pdp") startPdp(root);
        else if (kind === "hdr") startHdr(root);
        else return;
        root.setAttribute("data-ks-armed", "1");
      } catch (err) {
        root.removeAttribute("data-ks-armed");
        if (typeof console !== "undefined" && console.warn) console.warn("[ks-sale-timers]", err);
      }
    });
  }

  var deb;
  function scheduleBoot() {
    clearTimeout(deb);
    deb = setTimeout(boot, 60);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);

  var main = document.getElementById("main");
  if (main && typeof MutationObserver !== "undefined") {
    var mo = new MutationObserver(function (records) {
      var hit = false;
      for (var i = 0; i < records.length; i++) {
        var rec = records[i];
        if (rec.type !== "childList") continue;
        rec.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var tag = node.nodeName;
          if (tag === "SCRIPT" || tag === "STYLE") return;
          if (node.matches && node.matches("[data-ks-timer-root]")) hit = true;
          else if (node.querySelector && node.querySelector("[data-ks-timer-root]")) hit = true;
        });
      }
      if (hit) scheduleBoot();
    });
    mo.observe(main, { childList: true, subtree: true });
  }

  if (document.readyState !== "loading") boot();
})();
